import script from "./vmsCustomAttributeGroupCredentialEdit.vue?vue&type=script&lang=js"
export * from "./vmsCustomAttributeGroupCredentialEdit.vue?vue&type=script&lang=js"

import "./vmsCustomAttributeGroupCredentialEdit.vue?vue&type=style&index=0&id=917873b0&lang=css"
import "./vmsCustomAttributeGroupCredentialEdit.vue?vue&type=style&index=1&id=917873b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-917873b0"]])

export default __exports__